(function () {
  'use strict';

  function setStatus(statusEl, message) {
    if (statusEl) statusEl.textContent = message;
  }

  function legacyCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (error) {
      ok = false;
    }
    document.body.removeChild(area);
    return ok;
  }

  function init(root) {
    if (root.dataset.photoHelpBound === 'true') return;
    root.dataset.photoHelpBound = 'true';

    var copyButton = root.querySelector('[data-photo-help-copy]');
    var statusEl = root.querySelector('[data-photo-help-status]');
    if (!copyButton) return;

    copyButton.addEventListener('click', function () {
      var message = root.getAttribute('data-help-message') || '';
      var done = function (ok) {
        setStatus(
          statusEl,
          ok
            ? 'Message copied — paste it into WhatsApp or an email.'
            : 'Copy did not work — please type the product name into your message instead.'
        );
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(message).then(
          function () { done(true); },
          function () { done(legacyCopy(message)); }
        );
      } else {
        done(legacyCopy(message));
      }
    });
  }

  // The compatibility checker (core-owned JS) renders a "Send photos for
  // review" card with a single contact-page button. Where the photo-help
  // widget is on the page, upgrade that card with the same WhatsApp and
  // email actions, keeping the contact form as a fallback link.
  function enhancePhotoBlocks() {
    var source = document.querySelector('[data-photo-help]');
    if (!source) return;
    var whatsapp = source.querySelector('.bs-photo-help__whatsapp');
    var email = source.querySelector('.bs-photo-help__email');
    if (!whatsapp || !email) return;

    document.querySelectorAll('.blusafe-compatibility__photo').forEach(function (block) {
      if (block.dataset.photoHelpEnhanced === 'true') return;
      block.dataset.photoHelpEnhanced = 'true';

      var actions = document.createElement('div');
      actions.className = 'bs-photo-help__actions bs-photo-help__actions--checker';
      actions.appendChild(whatsapp.cloneNode(true));
      actions.appendChild(email.cloneNode(true));

      var original = block.querySelector('a.bs-btn');
      if (original) {
        var fallback = document.createElement('p');
        fallback.className = 'bs-photo-help__fallback';
        var contactLink = document.createElement('a');
        contactLink.href = original.getAttribute('href') || '/pages/contact';
        contactLink.textContent = 'use our contact form';
        fallback.append('Prefer not to use WhatsApp or email? You can also ');
        fallback.appendChild(contactLink);
        fallback.append('.');
        original.replaceWith(actions);
        actions.insertAdjacentElement('afterend', fallback);
      } else {
        block.appendChild(actions);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-photo-help]').forEach(init);
    enhancePhotoBlocks();
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);

  var observer = new MutationObserver(enhancePhotoBlocks);
  observer.observe(document.body, { childList: true, subtree: true });
})();
